export function isRefetchingWithNewParams(query: {
  isFetching: boolean;
  isPlaceholderData: boolean;
}): boolean {
  return query.isFetching && query.isPlaceholderData;
}
